import { render, staticRenderFns } from "./OnlineTraining.vue?vue&type=template&id=4ece7fce"
import script from "./OnlineTraining.vue?vue&type=script&lang=js"
export * from "./OnlineTraining.vue?vue&type=script&lang=js"
import style0 from "./OnlineTraining.vue?vue&type=style&index=0&id=4ece7fce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports